<script>
  import { navigate } from "svelte-routing";
    /* Executable code section of the program */
    //Tools importation
  import { auth } from "../apis/APIS";
  import { isProtectedRoute } from "../apis/storage";
  import { onAuthStateChanged } from "firebase/auth";
  import { onMount } from "svelte";


  //Auxiliary variables
  let timerLoader = false
  let pathname

    //Logged-in session verification
  onMount(() => {
    onAuthStateChanged(auth, async (user) => {
      if (user) {
		$isProtectedRoute = true;
      } else { 
        pathname = window.location.pathname.split("/")[1];
      if (pathname !== "resetPassword") {
        navigate("/")
      }
      }
    });
    // Temporizador del loader
    setTimeout(() => (timerLoader = true), 1500);
  });
    
    /* End of the section */
</script>
<!-- Section to place the HTML code -->
 {#if $isProtectedRoute}
 <section class="footerContainer">
     <div class="informationSection">
         <div class="infoContent">
             <h3>JackLeckerman</h3>
             <p>Trlinská 71, Šenkvice 90081 Slovakia, EU</p>
             <p>info@jackleckerman.com</p>
             <p>+421 948 686 696</p>
             <p>Registered in the business register: Bratislava I odd.Sro., vl.č.57280/B</p>
         </div>
         <div class="btnSocialMedia">
             <a target="_blank" href="https://www.facebook.com/JackLeckerman/">
                 <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-facebook" viewBox="0 0 16 16">
                     <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951"/>
                 </svg>
             </a>
             <a target="_blank" href="https://x.com/JackLeckerman?mx=2">
                 <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-twitter" viewBox="0 0 16 16">
                     <path d="M5.026 15c6.038 0 9.341-5.003 9.341-9.334q.002-.211-.006-.422A6.7 6.7 0 0 0 16 3.542a6.7 6.7 0 0 1-1.889.518 3.3 3.3 0 0 0 1.447-1.817 6.5 6.5 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.32 9.32 0 0 1-6.767-3.429 3.29 3.29 0 0 0 1.018 4.382A3.3 3.3 0 0 1 .64 6.575v.045a3.29 3.29 0 0 0 2.632 3.218 3.2 3.2 0 0 1-.865.115 3 3 0 0 1-.614-.057 3.28 3.28 0 0 0 3.067 2.277A6.6 6.6 0 0 1 .78 13.58a6 6 0 0 1-.78-.045A9.34 9.34 0 0 0 5.026 15"/>
                 </svg>
             </a>
             <a target="_blank" href="https://www.linkedin.com/company/jack-leckerman/">
                 <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-linkedin" viewBox="0 0 16 16">
                     <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225z"/>
                 </svg>
             </a>
         </div>
     </div>
     <div class="quickLinkSection">
         <h3>Quick Links</h3>
         <div class="contentLinks">
             <p class="links"><a target="_blank" href="https://jackleckerman.com/contact-us/">> Contact Us</a>
             <p class="links"><a target="_blank" href="https://jackleckerman.com/wp-content/uploads/2020/07/Privacy-policy.pdf">> Privacy Policy</a></p>
             <p class="links"><a target="_blank" href="https://jackleckerman.com/wp-content/uploads/2020/07/Organizers-details.pdf">> Organizer’s Details</a></p>
             <p class="links"><a target="_blank" href="https://jackleckerman.com/wp-content/uploads/2020/07/Terms-and-conditions.pdf">> Terms and Conditions</a></p>
         </div>
         
         <div class="imgContainer">
             <img src="https://res.cloudinary.com/dgx8kh6hn/image/upload/v1740501352/LogoWhite_ti8e1y.png" alt="Logo" class="imgLogo">
         </div> 
          
     </div>
 </section>
 {/if}


<!-- End of the section -->
<style>
    /* Section to place the code styles */
    .footerContainer{
        width: 100%;
        height: auto;
        min-height:200px;
        background-color: #222222;
        display: flex;
        justify-content: center;
        padding: 20px 30px;
    }
    .informationSection{
        width: 45%;
        padding: 50px 70px;
        margin-right: 50px;
    }
    h3,p,a{
        color: white;
    }
    a{
        text-decoration: none;
    }
    .bi{
        margin: 20px 10px;
    }
    .links{
        border-bottom: 1px solid white;
        margin: 10px 0;
        padding: 5px 0;
    }
    .contentLinks{
        width: 60%;
    }.infoContent{
        width: 70%;
    }
    .quickLinkSection{
        width: 55%;
        padding: 50px 0;
        margin-left: 50px;
    }
    img{
        height: auto;
        width: 50%;
    }
    /* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
    
}
/* /////////Cellphones ///////// */
@media (max-width: 700px) {
    .footerContainer{
        width: 100%;
        height: auto;
        min-height:200px;
        background-color: #222222;
        display: flex;
        flex-direction: column;
        padding: 20px 30px;
    }
    .informationSection{
        width: 100%;
        padding: 20px;
        margin-right: 0;
    }
    h3,p,a{
        color: white;
    }
    a{
        text-decoration: none;
    }
    .bi{
        margin: 20px 10px;
    }
    .links{
        border-bottom: 1px solid white;
        margin: 10px 0;
        padding: 5px 0;
    }
    .contentLinks{
        width: 60%;
    }.infoContent{
        width: 70%;
    }
    .quickLinkSection{
        width: 100%;
        padding: 20px;
        margin-left: 0;
    }
    img{
        height: auto;
        width: 70%;
    }
}

    /* End of the section */
</style>
